/* eslint-disable array-callback-return */
import React from "react";
import {
  AppBar,
  Button,
  Container,
  Divider,
  IconButton,
  Paper,
  Tooltip,
  Typography,
  FormControlLabel,
  Radio,
  RadioGroup,
  FormLabel,
} from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DatasetIcon from "@mui/icons-material/Dataset";
import DialogTitle from "@mui/material/DialogTitle";
import Draggable from "react-draggable";
import Select from "@mui/material/Select";
import moment from "moment";
import { useSelector } from "react-redux";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
} from "@mui/x-data-grid";
import BarChart from "../Charts/BarChart";
import API from "../../Api/api";
import toast from "react-hot-toast";
import { startOfMonth, endOfMonth } from "../../ui/today";
const currencyFormatter = new Intl.NumberFormat("en-US", {
  style: "decimal",
});

const columns = [
  {
    field: "branch",
    headerName: "Branch",
    minWidth: 170,
    align: "left",
  },
  {
    field: "amount",
    headerName: "Amount",
    minWidth: 170,
    align: "left",
    valueFormatter: ({ value }) => currencyFormatter.format(value),
  },
];
function PaperComponent(props) {
  return (
    <Draggable
      handle='#draggable-dialog-title'
      cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}
function createData(
  id,
  branch,
  category,
  designation,
  department,
  description,
  employee_name,
  date,
  amount,
  sanctioned_by,
  approved_by
) {
  return {
    id,
    branch,
    category,
    designation,
    department,
    description,
    employee_name,
    date,
    amount,
    sanctioned_by,
    approved_by,
  };
}
function CustomToolbar() {
  return (
    <GridToolbarContainer
      style={{ backgroundColor: "#75CA93 ", color: "white" }}>
      <GridToolbarExport style={{ color: "white" }} />
    </GridToolbarContainer>
  );
}
export default function BranchClaimReport() {
  const [open, setOpen] = React.useState(false);
  const [showingData, setShowingData] = React.useState("data");
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const departments = useSelector((state) => state.departments.depart);
  const category = useSelector((state) => state.category.cart);
  const locations = useSelector((state) => state.locations);
  const approvedClaims = useSelector((state) => state.approved);
  const [approved, setApproved] = React.useState(approvedClaims);
  const [queryData, setQueryData] = React.useState({
    branch: "",
    category: "",
    department: "",
    claim_start: "",
    claim_end: "",
  });

  const branch = queryData.branch
    ? `&branch[eq]=${queryData.branch.toLowerCase()}`
    : "";
  const categoryQuery = queryData.category
    ? `&category[eq]=${queryData.category}`
    : "";
  const departmentQuery = queryData.department
    ? `&department[eq]=${queryData.department}`
    : "";
  const claimStartQuery = queryData.claim_start
    ? `&date[gte]=${queryData.claim_start}`
    : "";
  const claimEndQuery = queryData.claim_end
    ? `&date[lte]=${queryData.claim_end}`
    : "";
  const designationQuery = queryData.designation
    ? `&designation[eq]=${queryData.designation}`
    : "";
  const query = `/api/v1/eClaim?status[eq]=approved${branch}${categoryQuery}${departmentQuery}${claimStartQuery}${designationQuery}${claimEndQuery}`;
  const fetchData = async () => {
    let fetchingId;
    try {
      fetchingId = toast.loading("Fetching data...");
      const res = await API.get(query);
      if (res.data) {
        setApproved(res.data);
      }
      toast.remove(fetchingId);
      toast.success("Data Loaded");
    } catch (error) {
      toast.remove(fetchingId);
      toast.error(error.message);
      setApproved(approvedClaims);
    }
  };

  React.useEffect(() => {
    if (showingData === "month") {
      const data = approvedClaims.filter(
        (d) =>
          moment(d.date) >= moment(startOfMonth) &&
          moment(d.date) < moment(endOfMonth)
      );
      setApproved(data);
    } else {
      setApproved(approvedClaims);
    }
  }, [showingData, approvedClaims]);
  function clearFilter() {
    if (showingData === "month") {
      const data = approvedClaims.filter(
        (d) =>
          moment(d.date) >= moment(startOfMonth) &&
          moment(d.date) < moment(endOfMonth)
      );
      setApproved(data);
      setQueryData({
        branch: "",
        category: "",
        department: "",
        claim_start: "",
        claim_end: "",
        designation: "",
      });
      return;
    }
    setQueryData({
      branch: "",
      category: "",
      department: "",
      claim_start: "",
      claim_end: "",
      designation: "",
    });
    setApproved(approvedClaims);
  }

  const rows = approved
    .filter((d) => d.status === "approved")
    .map((data) =>
      createData(
        data.claim_code,
        data.branch,
        data.category,
        data.designation || "staff",
        data.department,
        data.description,
        data.employee_name,
        moment(data.date).format("DD-MM-YYYY"),
        data.amount,
        data.sanctioned_by,
        data.approved_by
      )
    );
  const totalAmount = rows.reduce((acc, obj) => acc + obj.amount, 0);
  const formattedAmount = totalAmount.toLocaleString();
  const groupedData = rows.reduce((result, item) => {
    const { branch, id, amount } = item;
    if (!result[branch]) {
      result[branch] = {
        branch,
        amount: 0,
      };
    }
    result[branch].id = id;
    result[branch].amount += amount;

    return result;
  }, {});

  // Converting the grouped data object back to an array (if needed)
  const groupedArray = Object.values(groupedData).sort(
    (a, b) => a.amount - b.amount
  );
  const name = [];
  const value = [];
  groupedArray.map((data) => {
    name.push(data.branch);
    value.push(data.amount);
  });

  return (
    <Paper style={{ paddingBottom: "50px" }}>
      <Container>
        <AppBar
          position='fixed'
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "10px",
            flexGrow: 1,
            marginTop: "60px",
            width: "95%",
            backgroundColor: "#ccc",
            color: "#000",
          }}>
          <div
            elevation={16}
            style={{
              fontSize: "14px",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}>
            <div
              style={{ display: "flex", flexDirection: "column", rowGap: 9 }}>
              <FormControl size='small' sx={{ m: 1, width: 140 }}>
                <InputLabel id='demo-simple-select-standard-label'>
                  Branch
                </InputLabel>
                <Select
                  labelId='demo-simple-select-standard-label'
                  id='demo-simple-select-standard'
                  value={queryData.branch}
                  onChange={(e) =>
                    setQueryData({ ...queryData, branch: e.target.value })
                  }
                  label='Category'>
                  <MenuItem value=''>
                    <em>None</em>
                  </MenuItem>
                  {locations?.map((data) => {
                    return (
                      <MenuItem key={data._id} value={data.name}>
                        {data.name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
            <div
              style={{ display: "flex", flexDirection: "column", rowGap: 9 }}>
              <FormControl size='small' sx={{ m: 1, width: 140 }}>
                <InputLabel id='demo-simple-select-standard-label'>
                  Department
                </InputLabel>
                <Select
                  labelId='demo-simple-select-standard-label'
                  id='demo-simple-select-standard'
                  value={queryData.department}
                  onChange={(e) =>
                    setQueryData({ ...queryData, department: e.target.value })
                  }
                  label='Category'>
                  <MenuItem value=''>
                    <em>None</em>
                  </MenuItem>
                  {departments.map((data) => (
                    <MenuItem key={data._id} value={data.department}>
                      {data.department}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <FormControl size='small' sx={{ m: 1, width: 140 }}>
                <InputLabel id='demo-simple-select-standard-label'>
                  Category
                </InputLabel>
                <Select
                  labelId='demo-simple-select-standard-label'
                  id='demo-simple-select-standard'
                  value={queryData.category}
                  onChange={(e) =>
                    setQueryData({ ...queryData, category: e.target.value })
                  }
                  label='Category'>
                  <MenuItem value=''>
                    <em>None</em>
                  </MenuItem>
                  {category.map((data) => (
                    <MenuItem key={data._id} value={data.category}>
                      {data.category}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <FormControl size='small' sx={{ m: 1, width: 140 }}>
                <InputLabel id='demo-simple-select-standard-label'>
                  Designation
                </InputLabel>
                <Select
                  labelId='demo-simple-select-standard-label'
                  id='demo-simple-select-standard'
                  value={queryData.designation}
                  onChange={(e) =>
                    setQueryData({ ...queryData, designation: e.target.value })
                  }
                  label='Designation'>
                  <MenuItem value=''>
                    <em>None</em>
                  </MenuItem>

                  <MenuItem value='staff'>staff</MenuItem>
                  <MenuItem value='non-staff'>non-staff</MenuItem>
                </Select>
              </FormControl>
            </div>

            <div style={{ display: "flex", flexDirection: "column" }}>
              <label
                style={{
                  fontWeight: "bold",
                  fontSize: "14px",
                  color: "#116149",
                }}
                htmlFor='acq-start-date'>
                Claim start date
              </label>
              <input
                value={queryData.claim_start}
                onChange={(e) =>
                  setQueryData({ ...queryData, claim_start: e.target.value })
                }
                style={{
                  // alignItems: "center",
                  alignText: "center",

                  fontSize: "16px",

                  borderRadius: "5px",
                  // backgroundColor: "#cccc",
                  border: "1px solid #3D4F58",
                }}
                id='acq-end-date'
                type='date'
                size='small'
              />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginLeft: "5px",
              }}>
              <label
                style={{
                  fontWeight: "bold",
                  fontSize: "14px",
                  color: "#116149",
                }}
                htmlFor='acq-start-date'>
                Claim end date
              </label>
              <input
                value={queryData.claim_end}
                onChange={(e) =>
                  setQueryData({ ...queryData, claim_end: e.target.value })
                }
                style={{
                  // alignItems: "center",
                  alignText: "center",

                  fontSize: "16px",

                  borderRadius: "5px",
                  // backgroundColor: "#cccc",
                  border: "1px solid #3D4F58",
                }}
                id='acq-end-date'
                type='date'
                size='small'
              />
            </div>
          </div>
          <div
            style={{
              // marginTop: "-35px",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              columnGap: "10px",
            }}>
            <div>
              <FormControl
                size='small'
                disabled={
                  queryData.branch ||
                  queryData.category ||
                  queryData.designation ||
                  queryData.claim_end ||
                  queryData.claim_start
                }>
                <FormLabel
                  style={{ fontSize: "12px" }}
                  id='demo-row-radio-buttons-group-label'>
                  Show Data For
                </FormLabel>
                <RadioGroup
                  value={showingData}
                  onChange={(e) => setShowingData(e.target.value)}
                  row
                  aria-labelledby='demo-row-radio-buttons-group-label'
                  name='row-radio-buttons-group'>
                  <FormControlLabel
                    value='month'
                    control={<Radio size='small' />}
                    label='This Month'
                  />
                  <FormControlLabel
                    value='data'
                    control={<Radio size='small' />}
                    label='All Data'
                  />
                </RadioGroup>
              </FormControl>
            </div>
            <Button
              onClick={fetchData}
              size='small'
              variant='contained'
              style={{ backgroundColor: "#75CA93" }}>
              Generate Report
            </Button>
            <Button
              onClick={clearFilter}
              size='small'
              variant='contained'
              style={{ backgroundColor: "#f47373" }}>
              Clear Filter
            </Button>
          </div>
        </AppBar>
      </Container>
      <Divider
        style={{
          backgroundColor: "#ccc",
          marginTop: "10px",
          marginBottom: "10px",
        }}
      />
      <Dialog
        open={open}
        onClose={handleClose}
        PaperComponent={PaperComponent}
        aria-labelledby='draggable-dialog-title'>
        <DialogTitle style={{ cursor: "move" }} id='draggable-dialog-title'>
          Data
        </DialogTitle>
        <DialogContent>
          <Paper>
            <DataGrid
              columns={columns}
              // getRowId={(row) => row.description}
              rows={groupedArray}
              {...groupedArray}
              slots={{ toolbar: CustomToolbar }}
              style={{ height: "40vh" }}
            />
            <Typography>Total cost:{formattedAmount}</Typography>
          </Paper>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <Typography
        onClick={handleClickOpen}
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          cursor: "pointer",
        }}>
        <Tooltip title='view Chart Data'>
          <IconButton>
            <DatasetIcon />
          </IconButton>
        </Tooltip>
        View Chart Data
      </Typography>
      <BarChart label={name} value={value} FilteredData={approved} />
    </Paper>
  );
}
